<mat-form-field class="form-field-input text-area"
                style="margin-top: 2px;">
  <mat-label>{{ title! | translate }}</mat-label>
  <textarea #inputControl="ngModel"
            (change)="onChange()"
            (mouseenter)="onMouseEnter()"
            (mouseleave)="onMouseLeave()"
            [(ngModel)]="value"
            [disabled]="disabled"
            [placeholder]="placeHolder! | translate"
            [required]="required"
            matInput
            title="{{value}}"></textarea>
  @if (inputControl.errors?.['required']) {
    <mat-error>{{ 'این فیلد اجباری است' }}</mat-error>
  }
</mat-form-field>
